import * as types from './constants';

export const initialState = {
  data: {
    summary: {
      links: null,
      clicks: null,
      sales: null,
      conversion_rate: null,
      users: null
    },
    comparison: {
      clicks: null,
      conversion_rate: null,
      gmv: null,
      links:null ,
      users: null
    }
  },
  loading: false,
  errors_api: {},
  message: null
};

const actions = {

  // Get Performance Snapshot
  [types.GET_PERFORMANCE_SNAPSHOT_REQUEST]: state => {
    const data = {
      ...state,
      loading: true
    };

    return { ...data };
  },

  [types.GET_PERFORMANCE_SNAPSHOT_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      data: {
        summary: {
          links: payload.summary.active_links,
          clicks: payload.summary.clicks,
          sales: payload.summary.gmv,
          conversion_rate: payload.summary.conversion_rate,
          users: payload.summary.users
        },
        comparison: {
          active_links: payload.comparison.comparison.active_links,
          clicks: payload.comparison.comparison.clicks,
          sales: payload.comparison.comparison.gmv,
          conversion_rate: payload.comparison.comparison.conversion_rate,
          users: payload.comparison.comparison.users
        }
      }
    };

    return { ...data };
  },

  [types.GET_PERFORMANCE_SNAPSHOT_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      listData: {
        ...state.listData,
        loading: false,
        errors_api: payload
      }
    };

    return { ...data };
  },

  [types.GET_PERFORMANCE_SNAPSHOT_RESET]: () => {

    return { ...initialState };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

